export var WeekDay;
(function (WeekDay) {
    WeekDay["MONDAY"] = "mon";
    WeekDay["TUESDAY"] = "tue";
    WeekDay["WEDNESDAY"] = "wed";
    WeekDay["THURSDAY"] = "thu";
    WeekDay["FRIDAY"] = "fri";
    WeekDay["SATURDAY"] = "sat";
    WeekDay["SUNDAY"] = "sun";
})(WeekDay || (WeekDay = {}));
//# sourceMappingURL=service-schedule-header.dto.js.map